export const PageHeader = ({ title, subtitle, action, testId = "page-title" }) => (
  <div className="mb-6 flex flex-col gap-4 sm:mb-8 sm:flex-row sm:items-end sm:justify-between">
    <div className="min-w-0">
      <div className="mb-2 h-1 w-10 rounded-full bg-[#FEB601]" />
      <h1 data-testid={testId} className="font-display text-2xl font-extrabold tracking-tight text-[#000B45] sm:text-3xl">
        {title}
      </h1>
      {subtitle && <p className="mt-1 text-sm text-gray-600 sm:text-base">{subtitle}</p>}
    </div>
    {action && <div className="shrink-0">{action}</div>}
  </div>
);
